import { useState } from 'react';
import type { VoidFunctionComponent } from 'react';

import useDebouncedCallback from '../../../../hooks/useDebouncedCallback';
import InputBase from '../../../generic/Forms/InputBase';

import ItemizedRuleSuggestionList from './ItemizedRuleSuggestionList';
import type { Suggestion } from './types';

import styles from './ItemizedRuleListInput.module.less';

type Props = {
  decoration: string;
  getSuggestions: (term: string) => Promise<Suggestion[]>;
  addRule: (id: string | null) => void;
};

const ItemizedRuleListInput: VoidFunctionComponent<Props> = ({
  decoration,
  addRule,
  getSuggestions,
}) => {
  const [input, setInput] = useState('');
  const [suggestions, setSuggestions] = useState<Suggestion[]>([]);
  const updateSuggestionList = useDebouncedCallback(async (queryTerm: string) => {
    if (!queryTerm) {
      setSuggestions([]);
      return;
    }
    try {
      const fetchedSuggestions = await getSuggestions(queryTerm);
      setSuggestions(fetchedSuggestions || []);
    } catch {
      setSuggestions([]);
    }
  }, 300);

  const onExternalClick = () => {
    setSuggestions([]);
    setInput('');
  };

  return (
    <div className={styles.inputWrapper}>
      <InputBase
        label={`Enter a ${decoration}`}
        value={input}
        onChange={(term) => {
          setInput(term);
          updateSuggestionList(term);
        }}
      >
        {(inputBaseProps) => (
          <div className="fossa-form__text-input__wrapper">
            <div className="fossa-form__text-input__wrapper__prefix">
              {decoration}
            </div>
            <input {...inputBaseProps} />
          </div>
        )}
      </InputBase>
      <ItemizedRuleSuggestionList
        onExternalClick={onExternalClick}
        selectRule={(id) => {
          setSuggestions([]);
          addRule(id);
        }}
        suggestions={suggestions}
      />
    </div>
  );
};

export default ItemizedRuleListInput;
